export const USER_TYPE_USER = "user";
export const USER_TYPE_STAFF = "staff";
export const USER_TYPE_AUDITOR = "auditor";
export const USER_TYPE_AUDITEE = "auditee";
export const USER_TYPE_INVESTIGATOR = "investigator";
export const USER_TYPE_ASSIGNEE = "assignee";
export const USER_TYPE_APPROVER = "approver";
export const USER_TYPE_RESPONSIBLE_PERSON = "responsible";
